import Qwery from 'qwery'
import Bean from 'bean'
import QueryString from 'query-string'

import { compareStringIgnoreCase } from './utilities'

export function insertAfter (newNode, referenceNode) {
  /*
        Insert element after another element

        newNode - element to insert
        referenceNode - element that the new node will be appended after
     */

  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling)
}

export function selectOptionInSelect (selector, optionValue, params) {
  let select = Qwery(selector)[0]
  let options = Qwery(`${selector} option`)

  for (var i = 0; i < options.length; i++) {
    if (compareStringIgnoreCase(options[i].innerHTML, optionValue)) {
      const urlParams = QueryString.parse(location.search) // eslint-disable-line

      /*
          Parse query parameters and check whether 'pre-select' parameter is present
          If yes, do not select the size, but keep the returning user message
       */
      if (!urlParams['size'] || params.easysize.opened === true) {
        select.selectedIndex = i
        Bean.fire(select, 'change')
      }
      return true
    }
  };

  return false
}



// WEBPACK FOOTER //
// ./src/js/components/dom-utilities.js